// @flow
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SearchMap from 'components/pages/SearchPage/Map'
import { type PropTypes as SearchContainerTypes } from 'containers/pages/SearchPage'
import Path from 'routes/path'
import type { Room } from 'types/www/room'
import {
  roomName,
  formatPagerText,
  roomImageURL,
} from 'frontend_core/dist/helpers/format'
import {
  convertToSearchConditionType,
  queryStringStringify,
} from 'helpers/search'
import { containerIds, setUIState } from 'redux/modules/ui'
import {
  type SearchConditionType,
  setSearchCondition,
} from 'redux/modules/search'

const mapZoomLevelDistance = {
  'zoom-20': 0.05,
  'zoom-19': 0.09,
  'zoom-18': 0.16,
  'zoom-17': 0.34,
  'zoom-16': 0.65,
  'zoom-15': 1.3,
  'zoom-14': 2.8,
  'zoom-13': 5.5,
  'zoom-12': 12.3,
  'zoom-11': 21.6,
  'zoom-10': 43,
  'zoom-9': 85,
  'zoom-8': 170,
  'zoom-7': 340,
  'zoom-6': 680,
  'zoom-5': 0,
  'zoom-4': 0,
  'zoom-3': 0,
  'zoom-2': 0,
  'zoom-1': 0,
}

const perPage = 20

class Container extends Component<SearchContainerTypes> {
  constructor(props: SearchContainerTypes) {
    super(props)

    this.handleSelectedRoom = this.handleSelectedRoom.bind(this)
    this.handleSelectedRoomMarker = this.handleSelectedRoomMarker.bind(this)
    this.handleChangeMap = this.handleChangeMap.bind(this)
    this.handleDragMap = this.handleDragMap.bind(this)
    this.handleReSearch = this.handleReSearch.bind(this)
    this.handleChangeMovingSearch = this.handleChangeMovingSearch.bind(this)
    this.handleChangePage = this.handleChangePage.bind(this)
    this.onLinkToSearchResultList = this.onLinkToSearchResultList.bind(this)
  }

  componentWillMount() {
    const { rooms, actions } = this.props
    if (rooms.length > 0) {
      actions.setUIState(containerIds.SEARCH, {
        selectedRoom: null,
        viewedRoomIds: [rooms[0].id],
        searchAtListView: this.props.location.search,
        isShowRoomAnnotation: true,
      })
    }
  }

  componentDidMount() {
    const popEvent = () => {
      const { setSearchCondition, setUIState } = this.props.actions
      window.removeEventListener('popstate', popEvent)
      setSearchCondition(
        convertToSearchConditionType(this.props.ui.searchAtListView),
      )
      setUIState(containerIds.SEARCH, { isShowMap: false })
    }
    window.addEventListener('popstate', popEvent)
  }

  componentWillReceiveProps(nextProps: PropTypes) {
    const { ui } = this.props
    const { ui: nextUI } = nextProps
    // 地図を動かして検索かつ、マップをドラッグして動かした時
    // (マーカーやサイドビュークリックで勝手に移動した時は再検索しない)
    if (
      nextUI.isMovingSearch &&
      ui.mapGeoInfo !== nextUI.mapGeoInfo &&
      nextUI.isMapDragged
    ) {
      this.handleReSearch()
    }
  }

  handleSelectedRoom: Function
  handleSelectedRoomMarker: Function
  handleChangeMap: Function
  handleDragMap: Function
  handleReSearch: Function
  handleChangeMovingSearch: Function
  handleChangePage: Function
  onLinkToSearchResultList: Function
  searchScrollContainer: HTMLElement
  roomMedia: HTMLElement

  // スペースを選択した時
  handleSelectedRoom(room: Room) {
    const { ui, actions } = this.props
    const viewedRoomIds = ui.viewedRoomIds
    viewedRoomIds.push(room.id)
    const state = { viewedRoomIds, isMapDragged: false }

    if (ui.selectedRoom && ui.selectedRoom.id == room.id) {
      state.selectedRoom = null
    } else {
      state.selectedRoom = room
    }
    state.isShowRoomAnnotation = false

    // 選択したスペースを保持、マップ上のRoomAnnotationを非表示
    actions.setUIState(containerIds.SEARCH, state)
  }

  // マーカーを選択した時
  handleSelectedRoomMarker(room: Room) {
    // サイドビューを対象スペースが見えるようにスクロール
    let roomIndex = -1
    if (this.searchScrollContainer && this.roomMedia) {
      this.props.rooms.some((r, i) => {
        if (r.id === room.id) {
          roomIndex = i
          return true
        }
        return false
      })
      this.searchScrollContainer.scrollTop =
        roomIndex * this.roomMedia.clientHeight
    }

    // スペース選択と同じ動き
    this.handleSelectedRoom(room)

    // マーカーの場合はマップ上のRoomAnnotationを表示する
    if (roomIndex >= 0) {
      const { actions } = this.props
      actions.setUIState(containerIds.SEARCH, { isShowRoomAnnotation: true })
    }
  }

  // マップの位置、ズームが変更されたとき
  handleChangeMap(mapGeoInfo: Object) {
    const { ui, actions } = this.props
    if (ui.isMovingSearch) {
      actions.setUIState(containerIds.SEARCH, {
        mapGeoInfo,
      })
    } else {
      actions.setUIState(containerIds.SEARCH, {
        isShowReSearchButton: true,
        mapGeoInfo,
      })
    }
  }

  // マップをドラッグで位置変更したとき
  handleDragMap() {
    const { actions } = this.props
    actions.setUIState(containerIds.SEARCH, { isMapDragged: true })
  }

  // 再検索ボタンが押された時
  handleReSearch() {
    const { ui, actions } = this.props
    const mapGeo = ui.mapGeoInfo

    // 再検索
    actions.setSearchCondition({
      page: 1,
      geocode: `${mapGeo.center.lat},${mapGeo.center.lng},${
        mapZoomLevelDistance[`zoom-${mapGeo.zoom}`]
      }km`,
    })

    actions.setUIState(containerIds.SEARCH, { isShowReSearchButton: false })
  }

  // マップを動かしながら検索 チェックが変更された時
  handleChangeMovingSearch() {
    const { ui, actions } = this.props
    actions.setUIState(containerIds.SEARCH, {
      isMovingSearch: !ui.isMovingSearch,
    })
  }

  // ページ変更
  handleChangePage(page: number) {
    const { actions } = this.props

    // 再検索
    actions.setSearchCondition({ page })
    window.scrollTo(0, 0)
    if (this.searchScrollContainer) {
      this.searchScrollContainer.scrollTo(0, 0)
    }
  }

  // リスト一覧へ
  onLinkToSearchResultList(e) {
    e.preventDefault()
    const { actions } = this.props
    actions.setSearchCondition(
      convertToSearchConditionType(this.props.ui.searchAtListView),
    )
    actions.setUIState(containerIds.SEARCH, { isShowMap: false })
  }

  render() {
    const { ui, search, rooms, pageInfo, isLoading } = this.props
    const pagerText = formatPagerText(pageInfo, perPage)
    const pagerProps = {
      totalCountDisplay: pagerText.totalCountDisplay,
      currentCountDisplay: pagerText.currentCountDisplay,
      resultsCount: pageInfo.resultsCount,
      totalCount: pageInfo.totalCount,
      currentPage: pageInfo.currentPage,
      totalPages: pageInfo.totalPages,
      nextPage: pageInfo.nextPage,
      hasNextPage: pageInfo.hasNextPage,
      previousPage: pageInfo.previousPage,
      hasPreviousPage: pageInfo.hasPreviousPage,
      onChangePage: this.handleChangePage,
      getPageLink: (page: number) => {
        const newSearchCondition = Object.assign({}, search, { page })
        return `${this.props.location.pathname}?${queryStringStringify(
          newSearchCondition,
        )}`
      },
    }

    const selectedRoomId = (ui.selectedRoom || {}).id

    // SearchMapPage の props形式に合うように変換
    const roomCardPropsList = rooms.map(room => {
      const reputationSummary = room.reputationSummary || {}
      const space = room.space || {}
      const price = (room.prices || [])[0] || {}
      let balloonColor = 'white'
      if (room.id === selectedRoomId) {
        balloonColor = 'blue'
      } else if (
        Array.isArray(ui.viewedRoomIds) &&
        ui.viewedRoomIds.indexOf(room.id) >= 0
      ) {
        balloonColor = 'gray'
      }
      const url = Path.room(space.username, room.uid || '')

      return {
        id: room.id,
        name: roomName(room),
        capacity: room.capacity,
        reputationScore: reputationSummary.score || 0,
        reputationCount: reputationSummary.count || 0,
        address: `${space.stateText || ''}${space.city || ''}${space.address1 ||
          ''}${space.address2 || ''}`,
        access: space.access || '',
        thumbnail: roomImageURL(room),
        latitude: space.latitude,
        longitude: space.longitude,
        price: price.minText || '',
        priceUnit: price.minUnitText || price.maxUnitText || '',
        roomLink: url,
        balloonColor,
        isDirectReservation: room.hasDirectReservationPlans,
        isTopHost: (room.owner || {}).rank === 1,
        isLastMinutesDiscount: room.hasLastMinuteDiscountPlans,
      }
    })

    const selectedRoom = rooms.find(r => r.id === selectedRoomId) || {}

    return (
      <SearchMap
        roomList={roomCardPropsList}
        selectedRoomId={selectedRoomId}
        pagerProps={pagerProps}
        onChangeSelectedRoom={this.handleSelectedRoom}
        latitude={selectedRoom.latitude}
        longitude={selectedRoom.longitude}
        isShowRoomAnnotation={ui.isShowRoomAnnotation}
        isShowReSearchButton={ui.isShowReSearchButton}
        onLinkToSearch={this.onLinkToSearchResultList}
        onClickMarker={this.handleSelectedRoomMarker}
        onRefSearchScrollContainer={ref => {
          this.searchScrollContainer = ref
        }}
        onRefRoomMedia={ref => {
          this.roomMedia = ref
        }}
        onChangeMap={this.handleChangeMap}
        onDragMap={this.handleDragMap}
        onClickReSearch={this.handleReSearch}
        onChangeCheckMovingSearch={this.handleChangeMovingSearch}
        listViewLink={`${Path.searchB()}?${queryStringStringify(search)}`}
        isLoading={isLoading}
        onClickClose={this.onLinkToSearchResultList}
        googleMapReactBootstrapURLKeys={{
          key: this.props.config.SPM_GOOGLE_API_KEY,
          libraries: 'places,geometry',
        }}
      />
    )
  }
}
function mapStateToProps(state: Object) {
  return state
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, setSearchCondition }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Container),
)



// WEBPACK FOOTER //
// ./src/containers/pages/SearchPage/Map.jsx